module.exports = __webpack_public_path__ + "static/scale-model-of-chief-seattle-fountain-in-seattle-washington-c39ee02d2c786e466191ca53e76fb1c6.png";